<!--  -->
<template>
  <div class="">
    <div class="top-banner" style="">
      <div class="">新墩镇双堡村智控中心</div>
      <img
        class="bannerlg"
        src="https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E5%A4%B4%E9%83%A8%E6%B5%81%E5%85%89.png"
        alt=""
      />
    </div>

    <div class="top-time">
      <div class="time-text">{{ time }}</div>
      <div class="flex justb time-text2">
        <div class="">{{ dayName }}</div>
        <div class="">{{ nowTime }}</div>
      </div>
    </div>
    <div class="flexCol alit tabbar">
      <div class="flex justb" style="width: 83vw">
        <div class="flex">
          <div
            class=""
            :class="
              tabbarIndex == 1 ? 'tabbar-left-check' : 'tabbar-left-default'
            "
            @click="openPage(1, '/')"
          >
            基地全景
          </div>
          <div
            class=""
            :class="
              tabbarIndex == 2 ? 'tabbar-left-check' : 'tabbar-left-default'
            "
            style="margin-left: 0px"
            @click="openPage(2, '/intelligentControl')"
          >
            智控物联
          </div>
          <div
            class=""
            :class="
              tabbarIndex == 3 ? 'tabbar-left-check' : 'tabbar-left-default'
            "
            style="margin-left: 0px"
            @click="openPage(3, '/cropModel')"
          >
            玉米模型
          </div>
          <div
            class=""
            :class="
              tabbarIndex == 4 ? 'tabbar-left-check' : 'tabbar-left-default'
            "
            style="margin-left: 0px"
            @click="openPage(4, '/fourEmotions')"
          >
            四情监管
          </div>
        </div>
        <div class="flex">
          <div
            class=""
            :class="
              tabbarIndex == 5 ? 'tabbar-right-check' : 'tabbar-right-default'
            "
            @click="openPage(5, '/farming')"
          >
            种植管理
          </div>
          <div
            class=""
            :class="
              tabbarIndex == 6 ? 'tabbar-right-check' : 'tabbar-right-default'
            "
            @click="openPage(6, '/fertilizationAnalysis')"
          >
            智能水肥
          </div>
          <div
            class=""
            :class="
              tabbarIndex == 7 ? 'tabbar-right-check' : 'tabbar-right-default'
            "
            @click="openPage(7, '/waterAffairs')"
          >
            智慧水务
          </div>
          <div
            class=""
            :class="
              tabbarIndex == 8 ? 'tabbar-right-check' : 'tabbar-right-default'
            "
            @click="openPage(8, '/intelligentAgriculturalMachinery')"
          >
            智能农机
          </div>
        </div>
      </div>
    </div>
    <div class="top-back flexCol alit" @click="loginOut">
      <img
        src="https://ica.obs.cn-south-1.myhuaweicloud.com/screen/home/%E8%BF%94%E5%9B%9E.png"
        alt=""
      />
      退出
    </div>
    <keep-alive v-if="$route.meta.keepAlive">
      <router-view style="width: 100vw" />
    </keep-alive>
    <router-view style="width: 100vw" v-else />
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      time: "",
      tabbarIndex: 1,
      dayName: "",
      nowTime: "",
    };
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {
    // 监听，当路由发生变化的时候执行
    $route(to, from) {
      switch (this.$router.currentRoute.path) {
        case "/":
          this.tabbarIndex = 1;
          break;
        case "/intelligentControl":
          this.tabbarIndex = 2;
          break;
        case "/cropModel":
          this.tabbarIndex = 3;
          break;
        case "/fourEmotions":
          this.tabbarIndex = 4;
          break;
        case "/farming":
          this.tabbarIndex = 5;
          break;
        case "/fertilizationAnalysis":
          this.tabbarIndex = 6;
          break;
        case "/waterAffairs":
          this.tabbarIndex = 7;
          break;
        case "/intelligentAgriculturalMachinery":
          this.tabbarIndex = 8;
          break;
        default:
          break;
      }
    },
  },
  // 方法集合
  methods: {
    openPage(index, url) {
      if (index != this.tabbarIndex) {
        this.tabbarIndex = index;
        if (index == 5) {
          this.$router.push({
            path: url,
            query: {
              type: 1,
            },
          });
        } else {
          this.$router.push(url);
        }
      }
    },
    //退出登录
    loginOut() {
      this.$confirm("是否确认退出登录?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          localStorage.clear();
          this.$router.replace("/login");
        })
        .catch(() => {});
    },
    updateClock() {
      const now = new Date();
      this.time = now.toLocaleTimeString();
    },
    formatChineseDate(date) {
      const days = [
        "星期日",
        "星期一",
        "星期二",
        "星期三",
        "星期四",
        "星期五",
        "星期六",
      ];
      this.dayName = days[date.getDay()];

      const year = date.getFullYear();
      const month = date.getMonth() + 1;
      const day = date.getDate();
      this.nowTime = `${year}年${month}月${day}日`;
    },
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
    // 每秒更新一次
    setInterval(this.updateClock, 1000);
    this.formatChineseDate(new Date());

    let path = this.$route.path;
    switch (path) {
      case "/":
        this.tabbarIndex = 1;
        break;
      case "/intelligentControl":
        this.tabbarIndex = 2;
        break;
      case "/cropModel":
        this.tabbarIndex = 3;
        break;
      case "/fourEmotions":
        this.tabbarIndex = 4;
        break;
      case "/farming":
        this.tabbarIndex = 5;
        break;
      case "/fertilizationAnalysis":
        this.tabbarIndex = 6;
        break;
      case "/waterAffairs":
        this.tabbarIndex = 7;
        break;
      case "/intelligentAgriculturalMachinery":
        this.tabbarIndex = 8;
        break;
      default:
        break;
    }
  },

  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {}, // 生命周期 - 挂载之前
  beforeUpdate() {}, // 生命周期 - 更新之前
  updated() {}, // 生命周期 - 更新之后
  beforeDestroy() {}, // 生命周期 - 销毁之前
  destroyed() {}, // 生命周期 - 销毁完成
  activated() {}, // 如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang='scss' scoped>
.top-back {
  position: fixed;
  top: 10px;
  right: 20px;
  z-index: 992;
  font-weight: 400;
  font-size: 14px;
  color: #ffffff;
  letter-spacing: 1px;
  cursor: pointer;

  img {
    width: 35px;
    height: 35px;
    margin-bottom: 2px;
  }
}

.tabbar {
  position: fixed;
  top: 22px;
  width: 100vw;
  z-index: 992;

  .tabbar-right-check {
    width: 104px;
    height: 50px;
    background-image: url("https://ica.obs.cn-south-1.myhuaweicloud.com/screen/home/%E5%8F%B3%E8%BE%B9%E9%80%89%E4%B8%AD%402x.png");
    background-size: 100% 100%;

    font-family: YouSheBiaoTiHei;
    font-size: 19px;
    color: #ffffff;
    line-height: 50px;
    text-align: center;
    cursor: pointer;
  }

  .tabbar-right-default {
    width: 104px;
    height: 50px;
    background-image: url("https://ica.obs.cn-south-1.myhuaweicloud.com/screen/home/%E5%8F%B3%E8%BE%B9%E6%9C%AA%E9%80%89%E4%B8%AD%402x.png");
    background-size: 100% 100%;

    font-family: YouSheBiaoTiHei;
    font-size: 19px;
    color: #ffffff;
    line-height: 50px;
    text-align: center;
    cursor: pointer;
  }

  .tabbar-left-check {
    width: 104px;
    height: 50px;
    background-image: url("https://ica.obs.cn-south-1.myhuaweicloud.com/screen/home/%E5%B7%A6%E8%BE%B9%E9%80%89%E4%B8%AD%402x.png");
    background-size: 100% 100%;

    font-family: YouSheBiaoTiHei;
    font-size: 18px;
    color: #ffffff;
    line-height: 50px;
    text-align: center;
    cursor: pointer;
  }

  .tabbar-left-default {
    width: 104px;
    height: 50px;
    background-image: url("https://ica.obs.cn-south-1.myhuaweicloud.com/screen/home/%E5%B7%A6%E8%BE%B9%E6%9C%AA%E9%80%89%E4%B8%AD%402x.png");
    background-size: 100% 100%;

    font-family: YouSheBiaoTiHei;
    font-size: 18px;
    color: #ffffff;
    line-height: 50px;
    text-align: center;
    cursor: pointer;
  }
}

.top-time {
  position: fixed;
  top: 8px;
  left: 18px;
  z-index: 991;

  .time-text2 {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 12px;
    color: #ffffff;
  }

  .time-text {
    font-family: YouSheBiaoTiHei;
    font-size: 28px;
    color: #ffffff;
    letter-spacing: 1px;
    font-style: normal;
    width: 130px;
  }
}

.top-banner {
  position: fixed;
  top: 0;
  z-index: 98;
  background-image: url("https://ica.obs.cn-south-1.myhuaweicloud.com/screen/top%402x.png");
  width: 100vw;
  height: 108px;
  background-size: 100% 100%;
  text-align: center;

  font-family: YouSheBiaoTiHei;
  font-size: 48px;
  color: #ffffff;
  line-height: 85px;
  letter-spacing: 4px;
  text-shadow: 0px 2px 4px #012969;
  font-style: normal;
  // background: linear-gradient(90deg, #FFFFFF 0%, #589DD6 100%);
  .bannerlg {
    width: 100vw;
    height: 200px;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 90;
  }
}
</style>